import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

// Un registro por cada inicio de sesión real (no por cada recarga de
// página con la sesión ya abierta) — para saber quién entró y cuándo.
export async function registrarAcceso({ email, nombre }) {
  try {
    await addDoc(collection(db, "accesos_app"), {
      email: email || "",
      nombre: nombre || email || "Desconocido",
      dispositivo: navigator.userAgent,
      fecha: new Date()
    });
  } catch (err) {
    console.error("Error registrando acceso:", err);
  }
}
